<template>
  <div class="container">
    <div class="box-title" id="scrollTo">
      <h4><i class="fal fa-plus-circle"></i> ແກ້ໄຂ ຂໍ້ມູນສາຂາສາງພັດສະດຸ</h4>
    </div>

    <div class="tabs" :style="{ marginTop: '10px', marginBottom: '0' }" v-if="canManageDcCode">
      <ul>
        <li :class="{ 'is-active': activeTab === 'info' }" @click="activeTab = 'info'">
          <a><i class="fal fa-store" :style="{ marginRight: '6px' }"></i>ຂໍ້ມູນສາຂາ</a>
        </li>
        <li :class="{ 'is-active': activeTab === 'dc_code' }" @click="activeTab = 'dc_code'">
          <a><i class="fal fa-barcode-alt" :style="{ marginRight: '6px' }"></i>ລະຫັດ DC (ຍິງອອກຫາ)</a>
        </li>
        <li :class="{ 'is-active': activeTab === 'inbound_destination' }" @click="activeTab = 'inbound_destination'">
          <a><i class="fal fa-exchange-alt" :style="{ marginRight: '6px' }"></i>ຮັບເຂົ້າແລ້ວປ່ຽນປາຍທາງ</a>
        </li>
        <li :class="{ 'is-active': activeTab === 'return_replacement' }" @click="activeTab = 'return_replacement'">
          <a><i class="fal fa-undo" :style="{ marginRight: '6px' }"></i>ຕີກັບໄປສາຂາທົດແທນ</a>
        </li>
        <li :class="{ 'is-active': activeTab === 'sender_policy' }" @click="activeTab = 'sender_policy'">
          <a><i class="fal fa-user-tag" :style="{ marginRight: '6px' }"></i>ຜູ້ສົ່ງປະຈຳສາຂາ / ບລັອກເບີ</a>
        </li>
        <li v-if="canManageManualFreight" :class="{ 'is-active': activeTab === 'manual_freight' }"
            @click="activeTab = 'manual_freight'">
          <a><i class="fal fa-hand-holding-usd" :style="{ marginRight: '6px' }"></i>ສິດປ້ອນຄ່າຂົນສົ່ງເອງ</a>
        </li>
        <li :class="{ 'is-active': activeTab === 'status_history' }" @click="activeTab = 'status_history'">
          <a><i class="fal fa-history" :style="{ marginRight: '6px' }"></i>ປະຫວັດສະຖານະ</a>
        </li>
      </ul>
    </div>

    <!-- DC-code prefix override tab (SuperAdmin / DC manager) -->
    <BranchDcCodePrefixTab v-if="activeTab === 'dc_code' && canManageDcCode"/>

    <!-- Inbound destination-change tab (SuperAdmin / DC manager) -->
    <BranchInboundDestinationTab v-if="activeTab === 'inbound_destination' && canManageDcCode"/>

    <!-- Return replacement tab: which OPEN branch receives this branch's returns while it is
         closed (SuperAdmin / DC manager) -->
    <BranchReturnReplacementTab v-if="activeTab === 'return_replacement' && canManageDcCode"/>

    <!-- Sender policy tab: the branch's own fixed sender (drop points) + the sender phones
         it refuses at its own counter — both only while it is the bill's ORIGIN branch -->
    <BranchSenderPolicyTab v-if="activeTab === 'sender_policy' && canManageDcCode"/>

    <!-- Manual-freight allowlist tab: who may type a parcel's freight — this branch's staff or
         individual users of it (SuperAdmin only; the API refuses every other role) -->
    <BranchManualFreightTab v-if="activeTab === 'manual_freight' && canManageManualFreight"/>

    <!-- Status history tab: every save that moved the open/closed status or the permanent-closure
         flag (from → to, who, when), read back out of `histories`. Every role that opens this page
         may read it, and the history icon beside the status select opens it too, so roles without
         the tab bar above can still reach it (its own "back" button returns to the form). -->
    <BranchStatusHistoryTab v-if="activeTab === 'status_history'" @back="activeTab = 'info'"/>

    <div v-show="activeTab === 'info'">
    <div class="columns is-multiline" :style="{ marginTop: '20px' }">
      <div class="column is-3">
        <div class="field">
          <div class="control">
            <label class="label">
              ລະຫັດສາຂາ
              <span class="text-danger">* {{ errors.first("prefix") }}</span>
              <span class="text-danger">
                {{ server_errors.prefix }}
              </span>
            </label>
            <input
              class="input"
              name="prefix"
              placeholder="ກະລຸນາປ້ອນລະຫັດກ່ອນ..."
              v-model="branches.prefix"
              v-validate="'required|min:3|max:25'"
            />
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <div class="control">
            <label class="label">
              ສາຂາພັດສະດຸ
              <span class="text-danger">* {{ errors.first("name") }}</span>
              <span class="text-danger">
                {{ server_errors.name }}
              </span>
            </label>
            <input
              class="input"
              name="name"
              placeholder="ກະລຸນາປ້ອນສາຂາກ່ອນ..."
              v-model="branches.name"
              v-validate="'required'"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <div class="control">
            <label class="label">
              ເບີໂທຕິດຕໍ່
              <span class="text-danger">* {{ errors.first("tel") }}</span>
              <span class="text-danger">
                {{ server_errors.tel }}
              </span>
            </label>
            <input
              class="input"
              name="tel"
              placeholder="ກະລຸນາປ້ອນເບີໂທຕິດຕໍ່ກ່ອນ..."
              v-model="branches.tel"
              v-validate="'required|min:6|max:15'"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <div class="control">
            <label class="label">
              ເບີໂທສຳຮອງ
              <span class="text-danger">{{ errors.first("tel2") }}</span>
              <span class="text-danger">
                {{ server_errors.tel2 }}
              </span>
            </label>
            <input
              class="input"
              name="tel2"
              placeholder="ກະລຸນາປ້ອນເບີໂທສຳຮອງ..."
              v-model="branches.tel2"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <div class="control">
            <label class="label">
              ສະຖານະເປິດ-ປິດ
              <a class="status-history-link" href="#" title="ເບິ່ງປະຫວັດການປ່ຽນສະຖານະ"
                 @click.prevent="activeTab = 'status_history'">
                <i class="fal fa-history"></i>
              </a>
            </label>
            <div class="select">
              <select class="input" v-model="branches.status">
                <option value="1">ເປີດ</option>
                <option value="0">ປິດ</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <div class="control">
            <label class="label">
              ອີເມວ
              <span class="text-danger"> {{ errors.first("email") }}</span>
              <span class="text-danger">
                {{ server_errors.email }}
              </span>
            </label>
            <input
              class="input"
              name="email"
              placeholder="ກະລຸນາປ້ອນອີເມວກ່ອນ..."
              v-model="branches.email"
              v-validate="'email'"
            />
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <div class="control">
            <label class="label">
              ເລືອກພາກ
              <span class="text-danger">* {{ errors.first("part") }}</span>
            </label>
            <div class="select">
              <select
                v-model="selectedPart.partId"
                name="part"
                @change="FilterProvinces(selectedPart.partId)"
              >
                <option
                  :value="part.partId"
                  v-for="(part, index) in parts"
                  :key="index"
                >
                  {{ FormatPart_To_Laos[part.name] }}-{{
                    FormatZoneToLaos[part.zone_code] || ""
                  }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <div class="control">
            <label class="label">
              ເລືອກເເຂວງ
              <span class="text-danger">* {{ errors.first("province") }}</span>
            </label>
            <div class="select">
              <select
                v-model="selectedProvince.proId"
                name="province"
                @change="FilterDistricts(selectedProvince.proId)"
              >
                <option
                  :value="province.proId"
                  v-for="(province, index) in provinces"
                  :key="index"
                >
                  {{ province.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <div class="control">
            <label class="label">
              ເລືອກເມືອງ
              <span class="text-danger">* {{ errors.first("district") }}</span>
            </label>
            <div class="select">
              <select
                v-model="selectedDistrict.distId"
                name="district"
                @change="FilterVillages(selectedDistrict.distId)"
              >
                <option
                  :value="district.distId"
                  v-for="(district, index) in districts"
                  :key="index"
                >
                  {{ district.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <div class="control">
            <label class="label">
              ເລືອກບ້ານ
              <span class="text-danger">* {{ errors.first("village") }}</span>
              <span class="text-danger">
                {{ server_errors.villageId }}
              </span>
            </label>
            <model-list-select
              :list="villages"
              v-model="selectedVillage.village_id"
              option-value="village_id"
              option-text="name"
              name="village"
              :is-disabled="!villages.length"
              :placeholder="
                villages.length ? 'ຄົ້ນຫາ ເເລະ ເລືອກບ້ານ...' : 'ບໍ່ມີຂໍ້ມູນບ້ານ...'
              "
            >
            </model-list-select>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <div class="control">
            <label class="label">
              ເລືອກປະເພດສາຂາ
              <span class="text-danger">* {{ errors.first("type") }}</span>
            </label>
            <div class="select">
              <select v-model="selectedType.id" name="type">
                <option
                  :value="type.id"
                  v-for="(type, index) in types"
                  :key="index"
                >
                  {{ type.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <div class="control">
            <label class="label">
              ເລືອກສູນຄັດເເຍກ
              <span class="text-danger">* {{ errors.first("district") }}</span>
            </label>
            <model-list-select
              :list="distributionCenters"
              v-model="branches.distribution_center_id"
              option-value="id"
              option-text="name"
              name="distributioncenter"
              placeholder="ຄົ້ນຫາ ເເລະ ເລືອກສູນຄັດເເຍກ..."
            >
            </model-list-select>
          </div>
        </div>
      </div>

      <div class="column is-12">
        <div class="columns">
          <div class="column is-2">
            <div class="control">
              <p :style="{ marginTop: '8px', fontWeight: 'bold' }">
                ເວລາລັອກສາຂາຍິງເຄື່ອງອອກ
              </p>
              <vue-timepicker
                v-model="lockOutboundTimeBranch"
                manual-input
                format="HH:mm"
              ></vue-timepicker>
            </div>
          </div>
          <div class="column is-2">
            <div class="control">
              <label
                class="listhead listhead-checkbox"
                :style="{ marginTop: '6px', marginLeft: '-3px' }"
              >
                <input type="checkbox" v-model="closeBranch" />
                <p :style="{ marginLeft: '10px', fontWeight: 'bold' }">
                  ລັອກສາຂາຊົ່ວຄາວ
                </p>
                <div class="control_indicator"></div>
              </label>
            </div>
          </div>
          <div class="column is-2">
            <div class="control">
              <label
                class="listhead listhead-checkbox"
                :style="{ marginTop: '6px', marginLeft: '-3px' }"
              >
                <input type="checkbox" v-model="lockDestinationBranch" />
                <p :style="{ marginLeft: '10px', fontWeight: 'bold' }">
                  ລັອກສາຂາບໍ່ໃຫ້ຈັດສົ່ງຫາ ຊົ່ວຄາວ
                </p>
                <div class="control_indicator"></div>
              </label>
            </div>
          </div>
          <div class="column is-2">
            <div class="control">
              <label
                class="listhead listhead-checkbox"
                :style="{ marginTop: '6px', marginLeft: '-3px' }"
              >
                <input type="checkbox" v-model="blockCreated" />
                <p :style="{ marginLeft: '10px', fontWeight: 'bold' }">
                  ລັອກບໍ່ໃຫ້ສ້າງບິນ
                </p>
                <div class="control_indicator"></div>
              </label>
            </div>
          </div>
          <div class="column is-2">
            <div class="control">
              <label
                class="listhead listhead-checkbox"
                :style="{ marginTop: '6px', marginLeft: '-3px' }"
              >
                <input type="checkbox" v-model="blockReceiveCod" />
                <p :style="{ marginLeft: '10px', fontWeight: 'bold' }">
                  ລັອກບໍ່ໃຫ້ບິນCODສົ່ງຫາ
                </p>
                <div class="control_indicator"></div>
              </label>
            </div>
          </div>
          <div class="column is-2">
            <div class="control">
              <label
                class="listhead listhead-checkbox"
                :style="{ marginTop: '6px', marginLeft: '-3px' }"
              >
                <input type="checkbox" v-model="blockReceiveCdc" />
                <p :style="{ marginLeft: '10px', fontWeight: 'bold' }">
                  ລັອກບໍ່ໃຫ້ບິນCDCສົ່ງຫາ
                </p>
                <div class="control_indicator"></div>
              </label>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-3">
            <div class="control">
              <label
                class="listhead listhead-checkbox"
                :style="{ marginTop: '6px', marginLeft: '-3px' }"
              >
                <input type="checkbox" v-model="blockReceiveLogistics" />
                <p :style="{ marginLeft: '10px', fontWeight: 'bold' }">
                  ລັອກບໍ່ໃຫ້ບິນLogisticສົ່ງຫາ
                </p>
                <div class="control_indicator"></div>
              </label>
            </div>
          </div>
          <div class="column is-3">
            <div class="control">
              <label
                class="listhead listhead-checkbox"
                :style="{ marginTop: '6px', marginLeft: '-3px' }"
              >
                <input type="checkbox" v-model="blockOriginCreated" />
                <p :style="{ marginLeft: '10px', fontWeight: 'bold' }">
                  ລັອກບໍ່ໃຫ້ສ້າງບິນຕົ້ນທາງ
                </p>
                <div class="control_indicator"></div>
              </label>
            </div>
          </div>
          <div class="column is-3">
            <div class="control">
              <label
                class="listhead listhead-checkbox"
                :style="{ marginTop: '6px', marginLeft: '-3px' }"
              >
                <input type="checkbox" v-model="isHide" />
                <p :style="{ marginLeft: '10px', fontWeight: 'bold' }">
                  ບໍ່ສະແດງ
                </p>
                <div class="control_indicator"></div>
              </label>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <div class="subtitle is-small promotion-title">
              ໂປຣໂມຊັ່ນ ສາຂາໃຫມ່
            </div>
            <div class="control">
              <label
                class="listhead listhead-checkbox"
                :style="{ marginTop: '6px', marginLeft: '-3px' }"
              >
                <input type="checkbox" v-model="isOpenNewBranchPromotion" />
                <p :style="{ marginLeft: '10px', fontWeight: 'bold' }">
                  {{
                    isOpenNewBranchPromotion
                      ? "ກົດເພື່ອ ປິດໂປຣໂມຊັ່ນ"
                      : "ກົດເພື່ອ ເປີດໂປຣໂມຊັ່ນ"
                  }}
                </p>
                <div class="control_indicator"></div>
              </label>
            </div>
            <div
              v-if="isOpenNewBranchPromotion"
              class="text-danger promotion-expired-title"
            >
              ຫມົດອາຍຸ: {{ this.newBranchPromotionExpiredDate }}
            </div>
          </div>
        </div>
      </div>

      <div class="column is-12">
        <div class="control">
          <label class="label">
            ເລືອກໂປຮໄຟລ
            <span class="text-danger">* {{ errors.first("profile") }}</span>
          </label>
        </div>
        <div class="box-upload-file" @click="triggerInputClick">
          <p class="text" :class="{ 'text-color': branches.profile }">
            <i class="fal fa-cloud-upload"></i>
            {{ fileName == "" ? branches.profile : fileName }}
          </p>
        </div>
        <div v-show="false" class="control">
          <input
            @change="onFileChange"
            ref="file"
            class="input input-ctn"
            type="file"
            name="profile"
            v-validate="'mimes:jpeg,jpg,gif,png|size:5120'"
            accept="image/png,image/gif,image/jpeg,image/jpg"
          />
        </div>
      </div>

      <!--      <div class="column is-12">-->
      <!--        <div class="control">-->
      <!--          <label class="listhead listhead-checkbox" :style="{marginTop: '6px', marginLeft: '-3px'}">-->
      <!--            <input-->
      <!--                type="checkbox"-->
      <!--                v-model="checkedAllServiceZone"-->
      <!--                @click="CheckedAllServiceZone()"-->
      <!--            />-->
      <!--            <p :style="{marginLeft: '10px', fontWeight: 'bold'}">-->
      <!--              ເຂດທີ່ບໍລິການ ສົ່ງເຖີງທີ່ - ຮັບເຖີງບ່ອນ-->
      <!--              ( <span :style="{color: 'crimson'}">{{ checkedServiceZone.length }}</span> )-->
      <!--            </p>-->
      <!--            <div class="control_indicator"></div>-->
      <!--          </label>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="column is-12">-->
      <!--        <div class="box-villages">-->
      <!--          <div class="columns is-multiline">-->
      <!--            <div class="column is-2" v-for="(village, index) in villages" :key="index">-->
      <!--              <div class="village">-->
      <!--                <label class="listhead listhead-checkbox">-->
      <!--                  <input-->
      <!--                      type="checkbox"-->
      <!--                      v-model="checkedServiceZone"-->
      <!--                      :value="village.village_id"-->
      <!--                      :id="village.village_id"-->
      <!--                  />-->
      <!--                  <p :style="{marginTop: '6px'}">{{ village.name }}</p>-->
      <!--                  <div class="control_indicator"></div>-->
      <!--                </label>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--            <div class="box-not-found" v-if="!villages.length">-->
      <!--              <p>-->
      <!--                ບໍ່ມີເຂດບໍລິການ ສົ່ງເຖີງທີ່ - ຮັບເຖີງບ່ອນ...-->
      <!--              </p>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="column is-6">
        <div class="field">
          <div class="control">
            <label class="label"> ທີ່ຢູ່ Lag,Lng </label>
            <input
              class="input"
              name="customer_address"
              placeholder="ຕົວຢ່າງ: lat,lng"
              v-model="selectLatLng"
            />
          </div>
        </div>
      </div>
      <div class="column is-3" :style="{ display: 'flex' }">
        <div
          ref="target"
          id="target"
          class="center"
          style="margin: 0; align-items: flex-start; padding-top: 19px"
        >
          <vs-button
            ref="button"
            flat
            class="form-btn-general"
            @click="focusFromLagLng"
          >
            <i class="fal fa-map-marked" :style="{ width: '35px' }"></i> Focus
          </vs-button>
        </div>
      </div>

      <div class="column is-12">
        <gmap-autocomplete
          ref="searchInput"
          class="input"
          placeholder="ຄົ້ນຫາເເຜນທີ່..."
          @place_changed="setPlace"
          :options="{ fields: ['geometry', 'formatted_address', 'name'] }"
        >
        </gmap-autocomplete>
        <span class="horizontal-divider"></span>
      </div>
      <div class="column is-12">
        <GmapMap :center="center" :zoom="16" style="width: 100%; height: 450px">
          <GmapMarker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            @click="center = m.position"
            :draggable="true"
            @dragend="onLocation"
            :icon="markerOptions"
            :animation="2"
            ref="markers"
          />
        </GmapMap>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12" :style="{ display: 'flex' }">
        <div ref="target" id="target" class="center">
          <div class="con-btns">
            <vs-button
              ref="button"
              flat
              @click="ValidateForm()"
              class="form-btn-loading"
              :loading="btnLoading"
            >
              <i class="fal fa-pencil-alt" :style="{ width: '35px' }"></i>
              ເເກ້ໄຂ ສາຂາສາງ
            </vs-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Danger Zone: Permanent Close Branch — SuperAdmin ONLY. branch-manage edits every
         other field on this form (branch::FULL_EDITOR_ROLES) but the backend refuses this one
         for them with a 422, so the control is not shown; the "already closed" notice below
         still is. -->
    <div
      class="danger-zone"
      v-if="canPermanentlyClose && (!branches.is_permanently_closed || permanentCloseLoading)"
    >
      <div class="danger-zone-header">
        <i class="fal fa-exclamation-triangle"></i>
        <span>ເຂດອັນຕະລາຍ (Danger Zone)</span>
      </div>
      <div class="danger-zone-content">
        <div class="danger-zone-warning">
          <h4><i class="fal fa-store-slash"></i> ປິດສາຂາຖາວອນ</h4>
          <p>
            ການປິດສາຂາຖາວອນຈະບໍ່ສາມາດກັບຄືນໄດ້. ສາຂານີ້ຈະຖືກປິດຕະຫຼອດໄປ ແລະ
            ບໍ່ສາມາດໃຊ້ງານໄດ້ອີກ.
          </p>
          <p class="warning-text">
            ກະລຸນາພິມ
            <strong>"permanent close"</strong> ເພື່ອຢືນຢັນການປິດສາຂາຖາວອນ
          </p>
        </div>
        <div class="danger-zone-input">
          <input
            class="input danger-input"
            type="text"
            v-model="permanentCloseConfirmText"
            placeholder="ພິມ permanent close ເພື່ອຢືນຢັນ..."
          />
        </div>
        <div class="danger-zone-action">
          <vs-button
            danger
            flat
            :disabled="!isPermanentCloseConfirmed"
            :loading="permanentCloseLoading"
            @click="PermanentCloseBranch"
            class="danger-btn"
          >
            <i class="fal fa-ban" :style="{ marginRight: '8px' }"></i>
            ປິດສາຂາຖາວອນ
          </vs-button>
        </div>
      </div>
    </div>

    <!-- Already Permanently Closed Notice -->
    <div class="danger-zone permanently-closed-notice" v-else-if="branches.is_permanently_closed">
      <div class="danger-zone-header">
        <i class="fal fa-exclamation-triangle"></i>
        <span>ສາຂານີ້ຖືກປິດຖາວອນແລ້ວ</span>
      </div>
      <div class="danger-zone-content">
        <p class="closed-message">
          <i class="fal fa-store-slash"></i>
          ສາຂານີ້ໄດ້ຖືກປິດຖາວອນແລ້ວ ແລະ ບໍ່ສາມາດໃຊ້ງານໄດ້ອີກ.
        </p>
        <p class="closed-message">
          <a class="status-history-link" href="#" @click.prevent="activeTab = 'status_history'">
            <i class="fal fa-history"></i> ເບິ່ງປະຫວັດການປ່ຽນສະຖານະ (ໃຜປິດ, ເມື່ອໃດ)
          </a>
        </p>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import MixinsAddBranches from "../../../../Mixins/Branch/Edit";
import { ValidateBranches } from "@coms/../../src/Plugins/Validation/Branch/Branch";
import BranchDcCodePrefixTab from "./BranchDcCodePrefixTab.vue";
import BranchInboundDestinationTab from "./BranchInboundDestinationTab.vue";
import BranchReturnReplacementTab from "./BranchReturnReplacementTab.vue";
import BranchSenderPolicyTab from "./BranchSenderPolicyTab.vue";
import BranchManualFreightTab from "./BranchManualFreightTab.vue";
import BranchStatusHistoryTab from "./BranchStatusHistoryTab.vue";
import { ModelListSelect } from "vue-search-select";

export default {
  mixins: [MixinsAddBranches],
  components: {
    BranchDcCodePrefixTab,
    BranchInboundDestinationTab,
    BranchReturnReplacementTab,
    BranchSenderPolicyTab,
    BranchManualFreightTab,
    BranchStatusHistoryTab,
    ModelListSelect,
  },

  data: () => ({
    // 'info' = the original branch form; 'dc_code' = the DC-code prefix override
    // tab; 'inbound_destination' = the inbound destination-change tab;
    // 'sender_policy' = the fixed-sender / blocked-sender-phones tab;
    // 'manual_freight' = who may type freight (manual-freight allowlist);
    // 'status_history' = who flipped open/closed or permanently closed the branch, and when.
    activeTab: "info",
  }),

  computed: {
    canManageDcCode() {
      return this.$can(["SuperAdmin", "service", "distributioncentermanager"]);
    },
    // Permanent closure is irreversible and stays with SuperAdmin alone (backend:
    // EditBranch::withValidator refuses it for every other role).
    canPermanentlyClose() {
      return this.$can(["SuperAdmin"]);
    },
    // The manual-freight allowlist API is SuperAdmin-only (the finance heads are themselves
    // restricted by the list and must not be able to put themselves on it).
    canManageManualFreight() {
      return this.$can(["SuperAdmin"]);
    },
  },

  created() {
    this.FetchData();
    this.FetchDistributionCenter();
    ValidateBranches(this);
  },
};
</script>

<style lang="scss">
// The history icon beside the open/closed select and inside the permanently-closed notice.
.status-history-link {
  margin-left: 6px;
  color: #195BFF;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    color: #0d3fb8;
    text-decoration: underline;
  }
}

.promotion-title {
  text-align: start;
  color: #0a0a0a;
}
.promotion-expired-title {
  text-align: start;
}
.container {
  margin-top: 40px;

  .title-login {
    font-size: 20px;
    color: $primary-color;
  }

  #target {
    margin: 0 auto;
    right: 10px;

    .con-btns {
      width: 200px;
    }
  }

  .input {
    font-family: $font;
  }
}

// Danger Zone Styles
.danger-zone {
  margin-top: 40px;
  border: 2px solid #dc3545;
  border-radius: 8px;
  overflow: hidden;

  .danger-zone-header {
    background-color: #dc3545;
    color: white;
    padding: 12px 20px;
    font-weight: bold;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 10px;

    i {
      font-size: 18px;
    }
  }

  .danger-zone-content {
    padding: 20px;
    background-color: #fff5f5;

    .danger-zone-warning {
      margin-bottom: 20px;

      h4 {
        color: #dc3545;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        gap: 8px;

        i {
          font-size: 20px;
        }
      }

      p {
        color: #666;
        margin-bottom: 8px;
        line-height: 1.6;
      }

      .warning-text {
        color: #dc3545;
        font-weight: 500;

        strong {
          background-color: #ffeaea;
          padding: 2px 8px;
          border-radius: 4px;
          font-family: monospace;
        }
      }
    }

    .danger-zone-input {
      margin-bottom: 20px;

      .danger-input {
        border-color: #dc3545;
        max-width: 400px;

        &:focus {
          border-color: #dc3545;
          box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.2);
        }
      }
    }

    .danger-zone-action {
      display: flex;
      justify-content: center;

      .danger-btn {
        background-color: #dc3545 !important;
        border-color: #dc3545 !important;
        color: white !important;

        &:hover:not(:disabled) {
          background-color: #c82333 !important;
          border-color: #bd2130 !important;
        }

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }
  }

  &.permanently-closed-notice {
    .danger-zone-content {
      .closed-message {
        color: #dc3545;
        font-size: 16px;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 10px;

        i {
          font-size: 24px;
        }
      }
    }
  }
}
</style>
